import {Box, Container, Typography} from "@material-ui/core";
import * as React from "react";

export default function Footer() {
    return(
        <Box sx={{ height: 30, width: "auto", textAlign: "center", p: 3, display: "flex", alignItems: "center",}} style={{ backgroundColor: "black"}}>
            <Container>
                <Box>
                    <Typography variant="subtitle2" gutterBottom component="div" style={{ color: "white", fontWeight: "bold" }}>
                      © 2024 BridgeCordsNext Co.,LTD
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}